/**
 * AEON Islands Orchestrator
 * Implementa Partial Hydration (Astro-like) para componentes interactivos.
 * Carga los scripts de los componentes bajo demanda (IntersectionObserver).
 */

export const initOrchestrator = () => {
    initHydration();
};

export const initHydration = () => {
    const islands = document.querySelectorAll('[data-hydrate]');
    
    const observerOptions = {
        root: null,
        rootMargin: '100px', // Pre-cargar un poco antes de que sea visible
        threshold: 0.1
    };

    const hydrate = async (element) => {
        const componentName = element.getAttribute('data-component');
        const strategy = element.getAttribute('data-hydrate');

        if (!componentName) return;

        console.log(`[Islands] Hydrating ${componentName} with strategy: ${strategy}`);

        try {
            // Carga dinámica del script de la isla
            // Nota: En producción, estos deben estar en /assets/js/islands/
            const scriptPath = `/assets/js/islands/${componentName}.js`;
            
            // Verificamos si ya está cargado para evitar duplicados
            if (document.querySelector(`script[src="${scriptPath}"]`)) return;

            const script = document.createElement('script');
            script.src = scriptPath;
            script.type = 'module';
            script.async = true;
            
            // Marcamos como cargando
            element.setAttribute('data-hydration-state', 'loading');
            
            script.onload = () => {
                element.setAttribute('data-hydration-state', 'ready');
                // Disparar evento nativo para que el componente se auto-inicialice si es necesario
                element.dispatchEvent(new CustomEvent('island:ready', { detail: { component: componentName } }));
            };

            document.head.appendChild(script);
        } catch (error) {
            console.error(`[Islands] Error hydrating ${componentName}:`, error);
            element.setAttribute('data-hydration-state', 'error');
        }
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                hydrate(entry.target);
                observer.unobserve(entry.target); // Solo hidratar una vez
            }
        });
    }, observerOptions);

    islands.forEach(island => {
        const strategy = island.getAttribute('data-hydrate');
        
        if (strategy === 'visible') {
            observer.observe(island);
        } else if (strategy === 'idle') {
            if ('requestIdleCallback' in window) {
                window.requestIdleCallback(() => hydrate(island));
            } else {
                setTimeout(() => hydrate(island), 200);
            }
        } else if (strategy === 'hover') {
            island.addEventListener('mouseenter', () => hydrate(island), { once: true });
        } else if (strategy === 'interaction') {
            const events = ['mousedown', 'touchstart', 'keydown'];
            const handler = () => {
                hydrate(island);
                events.forEach(e => island.removeEventListener(e, handler));
            };
            events.forEach(e => island.addEventListener(e, handler, { passive: true }));
        } else if (strategy === 'instant') {
            hydrate(island);
        }
    });
};
